<template>
  <div class="login-page">
    <div class="content-area">
      <Row>
        <Col span="12"></Col>
        <Col span="12">
          <div class="login-form-area">
            <div class="title">登录账号</div>
            <Form ref="formInline" :model="formInline" :rules="ruleInline">
              <FormItem prop="username">
                <Input type="text" v-model="formInline.username" placeholder="Username">
                  <Icon type="ios-person-outline" slot="prepend"></Icon>
                </Input>
              </FormItem>
              <FormItem prop="password">
                <Input type="password" v-model="formInline.password" placeholder="Password">
                  <Icon type="ios-lock-outline" slot="prepend"></Icon>
                </Input>
              </FormItem>
              <FormItem>
                <Button
                  class="submitBtn"
                  type="primary"
                  @click="handleSubmit('formInline')"
                  :loading="login.click"
                >{{login.text}}</Button>
              </FormItem>
            </Form>
          </div>
        </Col>
      </Row>
      <span class="company">Copyright © 20019-2039 搭个圈</span>
    </div>
  </div>
</template>

<script>
import navJSON from './nav.json';
export default {
  data() {
    return {
      login: {
        click: false,
        text: '登 录'
      },
      formInline: {
        username: '',
        password: ''
      },
      ruleInline: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 5, max: 15, message: '长度必须5-15个字符', trigger: 'blur' }
        ],
        password: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入密码'));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.login.click = true
          this.login.text = '正 在 登 录'
          this.$Message.success('登录成功!');
          this.$store.commit('SET_NAVS', navJSON)
          this.$store.commit('SET_USER_INFO', { userName: '管理员' })
          this.$router.replace({ path: '/index' })
        } else {
          return false
        }
      })
    }
  }
}

</script>
<style lang='scss' scoped>
.login-page {
  height: 100%;
  width: 100%;
  background: url("../../assets/images/login-back-ground.png") no-repeat center
    center;
  background-size: 100% 100%;
  text-align: center;
  .content-area {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -300px;
    margin-left: -550px;
    width: 1100px;
    height: 600px;
    background: url("../../assets/images/login-back-ground_accessories.png")
      no-repeat center center;
    background-size: 100% 100%;
    .login-form-area {
      width: 360px;
      margin: 160px auto;
      .title {
        margin-bottom: 40px;
        font-size: 30px;
        color: #0088f4;
        font-weight: bold;
      }
    }
    .submitBtn {
      width: 360px;
      border-radius: 10px;
      padding-right: 40px;
      margin-top: 10px;
      -webkit-box-shadow: 0px 3px 3px #c8c8c8;
      box-shadow: 0px 3px 3px #c8c8c8;
    }
    .company {
      position: absolute;
      bottom: 20px;
      right: 20px;
      font-size: 10px;
      color: #666666;
    }
  }
}
</style>